import React from "react";

const ReceiptCard = ({
  purchaseData,
  totals,
  receiptNumber,
  receiptDate,
  receiptTime,
  formatEventDate,
  formatEventTime,
  paymentSuccessMessage,
  isDownloading,
  onViewTicket,
}) => {
  return (
    <div className="payment-receipt-card">
      {paymentSuccessMessage && (
        <div className="payment-success-message">
          <span>✓</span>
          <span>{paymentSuccessMessage}</span>
        </div>
      )}

      <div className="payment-receipt-layout">
        {/* LEFT: Event details only */}
        <div className="payment-receipt-layout__left">
          <div className="payment-receipt-header">
            <div className="payment-receipt-header__titles">
              <h2 className="payment-receipt-title">Payment Receipt</h2>
              <div className="payment-receipt-meta">
                <div>Paid on {receiptDate} at {receiptTime}</div>
              </div>
            </div>
          </div>

          <section className="payment-receipt-section">
            <h3 className="payment-section-title">Event Details</h3>
            <div className="payment-event-summary">
              <h4 className="payment-event-summary__title">
                {purchaseData.event?.name || "Event"}
              </h4>
              <div className="payment-event-summary__grid">
                <div className="payment-event-summary__item">
                  <span className="payment-event-summary__label">Location</span>
                  <span>{purchaseData.event?.location || "TBA"}</span>
                </div>
                <div className="payment-event-summary__item">
                  <span className="payment-event-summary__label">Date</span>
                  <span>
                    {purchaseData.event?.formattedDate ||
                      formatEventDate(purchaseData.event?.startdate ||
                        purchaseData.event?.start_date ||
                        purchaseData.event?.date) ||
                      "TBA"}
                  </span>
                </div>
                <div className="payment-event-summary__item">
                  <span className="payment-event-summary__label">Time</span>
                  <span>
                    {purchaseData.event?.formattedTime ||
                      formatEventTime(purchaseData.event?.time ||
                        purchaseData.event?.start_time) ||
                      "TBA"}
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* RIGHT: Your tickets + pricing */}
        <div className="payment-receipt-layout__right">
          <div className="payment-receipt-total">
            <div className="payment-receipt-total__label">Amount Paid</div>
            <div className="payment-receipt-total__value">
              {totals && `R ${totals.total.toLocaleString("en-ZA", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`}
            </div>
          </div>

          <section className="payment-receipt-section">
            <h3 className="payment-section-title">Your Tickets & Pricing</h3>
            <div className="payment-receipt-details-list">
              {purchaseData.packages.map((pkg, index) => (
                <div key={index} className="payment-package-item">
                  <div className="payment-package-item__info">
                    <div className="payment-package-item__name">
                      {pkg.name || "Standard Ticket"}
                    </div>
                    <div className="payment-package-item__details">
                      Quantity: {pkg.tickets || 1}
                    </div>
                  </div>
                  <div className="payment-package-item__price">{pkg.amount}</div>
                </div>
              ))}
            </div>
          </section>

          <div className="payment-totals">
            <div className="payment-totals__row">
              <span>Subtotal</span>
              <span>
                {`R ${totals.subtotal.toLocaleString("en-ZA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
              </span>
            </div>
            <div className="payment-totals__row">
              <span>Service Fee</span>
              <span>
                {`R ${(totals.serviceFee ?? totals.tax ?? 0).toLocaleString("en-ZA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
              </span>
            </div>
            <div className="payment-totals__final">
              <span>Total Paid</span>
              <span>
                {`R ${totals.total.toLocaleString("en-ZA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
              </span>
            </div>
          </div>

          <section className="payment-receipt-section payment-tickets-list">
            <h3 className="payment-section-title">Download Your Tickets</h3>
            {purchaseData.packages.map((pkg, index) => (
              <div key={index} className="payment-ticket-item">
                <div className="payment-ticket-item__info">
                  <div className="payment-ticket-item__name">
                    {pkg.name || "Standard Ticket"}
                  </div>
                  <div className="payment-ticket-item__quantity">
                    {pkg.tickets || 1} ticket(s)
                  </div>
                </div>
                <button
                  type="button"
                  className={`payment-ticket-item__button${
                    isDownloading[index] ? " payment-ticket-item__button--disabled" : ""
                  }`}
                  onClick={() => onViewTicket(pkg, index)}
                  disabled={!!isDownloading[index]}
                >
                  {isDownloading[index] ? "Loading..." : "View"}
                </button>
              </div>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReceiptCard;
